import React, { useEffect, useState } from "react";
import axios from "../axios/axios";
import NotificacaoDeSucesso from "../Notificacao/NotificacaoDeSucesso";
import NotificacaoDeErro from "../Notificacao/NotificacaDeErro";

function CaptacaoForm(props) {
  const [captacao, setCaptacao] = useState({
    nomenclatura_captada: "Defiro a Penhora",
    tipo_captacao: "Mediata",
    ligacao_frutifera: "Não",
    status: props.status,
  });
  const [id, setId] = useState(props.id);
  // const [mostrarNotificacao, setMostrarNotificacao] = useState(false);

  useEffect(() => {
    if (props.editing) {
      console.log(props.captacaoAntiga)
      setCaptacao({
        ...captacao,
        ...props.captacaoAntiga,
        status: props.status,
      });
    } else {
      setCaptacao({
        nomenclatura_captada: "Defiro a Penhora",
        tipo_captacao: "Mediata",
        ligacao_frutifera: "Não",
        status: props.status,
      });
    }
  }, [props.editing, props.captacaoAntiga]);

  const verifyData = (data) => {
    const dataChecked = {};
    if (data.data_captacao && !data.data_captacao?.includes("T"))
      data.data_captacao = new Date(data.data_captacao + " ").toISOString();
    Object.keys(data).forEach((e) =>
      data[e]?.length >= 1 ? (dataChecked[e] = data[e]) : false,
    );
    return dataChecked;
  };

  const [mostrarNotificacao, setMostrarNotificacao] = useState(false);
  const [mostrarNotificacaoDeErro, setMostrarNotificacaoDeErro] =
    useState(false);
  const [msn, setMsn] = useState("");

  const updateCaptacao = async (form) => {
    form.preventDefault();
    delete captacao["favoritos"];
    const checkedData = verifyData(captacao);
    checkedData["status"] = props.status;
    try {
      const { data } = await axios.put(`/captacao/${id}`, checkedData);
      props.setCaptacaoGeral((prevCaptacoes) => {
        // const filtradas = prevCaptacoes.filter((e) => e.id !== id);
        // return [...filtradas, data];
        const index = prevCaptacoes.findIndex((e) => e.id == id);
        return [
          ...prevCaptacoes.slice(0, index),
          data,
          ...prevCaptacoes.slice(index + 1),
        ];
      });
      setMsn("Captação atualizada com sucesso");
      console.log(setMsn);

      setMostrarNotificacao(true);
      props.setCaptacaoAntiga(null);
      // Resetando o estado após a atualização
      resetForm();
    } catch (error) {
      console.log(error);
      setMsn(
        `Erro ao atualizar a captação${error.response.data.message && ": " + error.response.data.message}`,
      );
      setMostrarNotificacaoDeErro(true);
    }
  };

  const createCaptacao = async (e) => {
    e.preventDefault();
    const checkedData = verifyData(captacao);
    checkedData["status"] = props.status;
    try {
      const { data } = await axios.post("/captacao", checkedData);
      props.setCaptacaoGeral([...props.captacaoGeral, data]);

      setMsn("Captação criada com sucesso!");
      setMostrarNotificacao(true);
      // Resetando o estado após a criação
      resetForm();
    } catch (error) {
      setMsn(
        `Erro ao atualizar a captação${error.response.data.message && ": " + error.response.data.message}`,
      );
      setMostrarNotificacaoDeErro(true);
    }
  };

  // Função para limpar o formulário
  const resetForm = () => {
    setCaptacao({
      data_captacao: "",
      processo: "",
      nomenclatura_captada: "Defiro a Penhora",
      tipo_captacao: "Mediata",
      exequente: "",
      adv_exequente: "",
      escritorio: "",
      responsavel: "",
      observacoes: "",
      ligacao_frutifera: "Não",
      num_bens: "",
      situacao: "",
      status: props.status,
      bairro: "",
      telefone: "",
      email: "",
    });
  };

  return (
    <>
      <form onSubmit={props.editing ? updateCaptacao : createCaptacao} className="!grid !grid-cols-2 gap-5">
        <div className="relative w-full max-w-sm">
          <input
            type="date"
            id="data_captacao"
            className={`peer w-full !px-6 !pt-6 !pb-2 border rounded-xl text-gray-900 !bg-white placeholder-transparent
              focus:outline-none focus:ring-2 focus:ring-blue-500`}
            value={captacao?.data_captacao?.split("T")[0] || ""}
            onChange={(e) =>
              setCaptacao({
                ...captacao,
                data_captacao: e.target.value,
              })
            }
            placeholder=" "
          />
          
          <label
            htmlFor="data_captacao"
            className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
              peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
              peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
              ${captacao?.data_captacao ? 'top-2 text-sm pointer-events-none' : ''}`}
          >
            Data de Captação
          </label>
</div>
        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="processo"
    className={`peer w-full !px-6 !pt-6 !pb-2 border rounded-xl text-gray-900 !bg-white placeholder-transparent
      focus:outline-none focus:ring-2 focus:ring-blue-500`}
    value={captacao?.processo || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, processo: e.target.value })
    }
    minLength={25}
    maxLength={25}
    required
    placeholder=" "
  />
  
  <label
    htmlFor="processo"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      ${captacao?.processo ? 'top-2 text-sm  pointer-events-none' : ''}`}
  >
    Processo
  </label>
</div>
        <div className="relative w-full max-w-sm">
  <select
    id="nomenclatura_captada"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 appearance-none 
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.nomenclatura_captada || "Defiro a Penhora"}
    onChange={(e) =>
      setCaptacao({
        ...captacao,
        nomenclatura_captada: e.target.value,
      })
    }
  >
    <option value="Defiro a Penhora">Defiro a Penhora</option>
    <option value="Avaliação do Imóvel">Avaliação do Imóvel</option>
    <option value="Averbação da Penhora">Averbação da Penhora</option>
    <option value="Escritório Fidelizado">Escritório Fidelizado</option>
    <option value="Termo de Penhora">Termo de Penhora</option>
    <option value="Nomeação Espontânea">Nomeação Espontânea</option>
    <option value="Laudo de Avaliação">Laudo de Avaliação</option>
    <option value="Leilão negativo">Leilão negativo</option>
    <option value="Indique Leiloeiro">Indique Leiloeiro</option>
    <option value="Indique Gestor">Indique Gestor</option>
    <option value="Indicar Leiloeiro">Indicar Leiloeiro</option>
    <option value="Indicar Gestor">Indicar Gestor</option>
    <option value="Indicação de leiloeiro">Indicação de leiloeiro</option>
    <option value="Leilão Extrajudicial">Leilão Extrajudicial</option>
    <option value="Homologo">Homologo</option>
    <option value="Realização da penhora">Realização da penhora</option>
    <option value="Registro de Penhora">Registro de Penhora</option>
    <option value="Hasta Pública">Hasta Pública</option>
    <option value="Designação de Leilão">Designação de Leilão</option>
    <option value="Venda Direta - TRT">Venda Direta - TRT</option>
    <option value="Recuperação Judicial">Recuperação Judicial</option>
    <option value="Escritório Fidelizado +">Escritório Fidelizado +</option>
    <option value="Falência Judicial">Falência Judicial</option>
  </select>

  <label
    htmlFor="nomenclatura_captada"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      ${captacao?.nomenclatura_captada ? 'top-2 text-sm' : ''}`}
  >
    Nomenclatura
  </label>

  <svg
    className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
</div>


       <div className="relative w-full max-w-sm">
  <select
    id="tipo_captacao"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 appearance-none 
             focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.tipo_captacao || "Mediata"}
    onChange={(e) =>
      setCaptacao({ ...captacao, tipo_captacao: e.target.value })
    }
  >
    <option value="Mediata">Mediata</option>
    <option value="Imediata">Imediata</option>
    <option value="Espontânea">Espontânea</option>
  </select>

  <label
    htmlFor="tipo_captacao"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      ${captacao?.tipo_captacao ? 'top-2 text-sm ' : ''}`}
  >
    Tipo de Captação
  </label>

  <svg
    className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
</div>


        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="responsavel"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.responsavel || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, responsavel: e.target.value })
    }
    placeholder="Responsável"
  />
  <label
    htmlFor="responsavel"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao?.responsavel ? 'top-2 text-sm ' : ''}`}
  >
    Responsável
  </label>
</div>

        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="exequente"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.exequente || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, exequente: e.target.value })
    }
    placeholder="Exequente"
  />
  <label
    htmlFor="exequente"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao?.exequente ? 'top-2 text-sm ' : ''}`}
  >
    Exequente
  </label>
</div>

        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="adv_exequente"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.adv_exequente || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, adv_exequente: e.target.value })
    }
    placeholder="Advogado Exequente"
  />
  <label
    htmlFor="adv_exequente"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao?.adv_exequente ? 'top-2 text-sm ' : ''}`}
  >
    Advogado Exequente
  </label>
</div>

        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="escritorio"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.escritorio || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, escritorio: e.target.value })
    }
    placeholder="Escritório"
  />
  <label
    htmlFor="escritorio"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao?.escritorio ? 'top-2 text-sm ' : ''}`}
  >
    Escritório
  </label>
</div>

        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="email"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao.email || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, email: e.target.value })
    }
    placeholder="Email"
  />
  <label
    htmlFor="email"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao.email ? 'top-2 text-sm ' : ''}`}
  >
    Email
  </label>
</div>
        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="telefone"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao.telefone || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, telefone: e.target.value })
    }
    placeholder="Telefone"
  />
  <label
    htmlFor="telefone"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao.telefone ? 'top-2 text-sm ' : ''}`}
  >
    Telefone
  </label>
</div>


        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="observacoes"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.observacoes || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, observacoes: e.target.value })
    }
    placeholder="Observações"
  />
  <label
    htmlFor="observacoes"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao?.observacoes ? 'top-2 text-sm ' : ''}`}
  >
    Observações
  </label>
</div>

        <div className="relative w-full max-w-sm">
  <select
    id="ligacao_frutifera"
    className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.ligacao_frutifera || "NÃO"}
    onChange={(e) =>
      setCaptacao({ ...captacao, ligacao_frutifera: e.target.value })
    }
  >
    <option value="NÃO">Não</option>
    <option value="SIM">Sim</option>
  </select>

  <label
    htmlFor="ligacao_frutifera"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      ${captacao?.ligacao_frutifera ? 'top-2 text-sm ' : ''}`}
  >
    Ligação Frutífera
  </label>

  <svg
    className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
</div>


        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="num_bens"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.num_bens || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, num_bens: e.target.value })
    }
    placeholder="Número de Bens"
  />
  <label
    htmlFor="num_bens"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao?.num_bens ? 'top-2 text-sm ' : ''}`}
  >
    Número de Bens
  </label>
</div>


        <div className="relative w-full max-w-sm">
  <input
    type="text"
    id="bairro"
    className="peer w-full px-6 pt-6 pb-2 border rounded-xl bg-white text-gray-900 placeholder-transparent
               focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={captacao?.bairro || ""}
    onChange={(e) =>
      setCaptacao({ ...captacao, bairro: e.target.value })
    }
    placeholder="Bairro"
  />
  <label
    htmlFor="bairro"
    className={`absolute left-6 top-2 text-gray-500 text-sm transition-all duration-200
      peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
      ${captacao?.bairro ? 'top-2 text-sm ' : ''}`}
  >
    Bairro
  </label>
</div>


        <button className="bg-black text-white py-3 !w-[100%] m-auto col-span-2">
          Cadastrar Nova Captação
        </button>
      </form>
      <NotificacaoDeSucesso
        mostrar={mostrarNotificacao}
        onClose={() => setMostrarNotificacao(false)}
        mensagem={msn}
      />
      <NotificacaoDeErro
        mostrar={mostrarNotificacaoDeErro}
        onClose={() => setMostrarNotificacaoDeErro(false)}
        mensagem={msn}
      />
    </>
  );
}

export default CaptacaoForm;
